const PT = require("prop-types");
const createReactClass = require("create-react-class");
const React = require("react");

const AssetsUtil = require("../../core/util/AssetsUtil");
const Avatar = require("../../core/view/Avatar");
const IconButton = require("../../core/view/IconButton");

const GradeChapter = require("../../../shared/GradeChapter");
const URLMake = require("../../../shared/URLMake");

const styles = require("./styles/ChapterPathFindMyAvatarButton.css");

module.exports = createReactClass({
	displayName: "ChapterPathFindMyAvatarButton",

	propTypes: {
		avatar: PT.object.isRequired,
		demo: PT.bool.isRequired,
		user: PT.object.isRequired,

		className: PT.string,
		disabled: PT.bool,
		handleClick: PT.func,
		demoAvatarModel: PT.object, // required if demo
	},

	render: function() {
		const {
			avatar,
			className,
			demo,
			demoAvatarModel,
			disabled,
			handleClick,
			user,
		} = this.props;
		// should never happen, but if it does, avoid rendering a broken button
		if (!disabled && !avatar.chapterID) return null;
		// exit if no demo avatar model for a demo component
		if (demo && !demoAvatarModel) return null;

		let link = null;
		const avatarModel = demo ? demoAvatarModel : user.model.avatar;
		if (!disabled) {
			const chapterContext = GradeChapter.chapterIDToContext(avatar.chapterID);
			link = URLMake.forChapterFromModel(chapterContext);
		}

		const button = (
			<IconButton
				iconClass={className}
				iconName={"findMyAvatar"}
				tooltipSize={"medium"}
				handleClick={handleClick}
				linkTo={link}
				iconImgPath={AssetsUtil.getButton("find-my-avatar")}
				buttonEffects={!disabled}
			>
				<Avatar
					className={styles.avatar}
					avatar={avatarModel}
					backgroundType={"hidden"}
				/>
			</IconButton>
		);
		return button;
	},
});
